export default "__VITE_ASSET__B17dohKI__"